/**
 * Post-auth redirect URLs per Auth0 application client_id.
 * Used by the reset-password-success screen to bounce the user
 * straight back to their product's login page after a successful reset.
 *
 * Must stay in sync with admin/lib/email/product-branding.ts (appUrl + loginPath).
 */

import { forEveryGuestmakerClient } from "./guestmakerClients";

const CLIENT_LOGIN_URL_MAP: Record<string, string> = {
  // ⚠️ EVERY GuestMaker client, including the iOS operator app.
  //
  // The default below is `admin.hotelinking.com/login`, so an unlisted client
  // sends its operator to a DIFFERENT PRODUCT after a password reset. That is
  // what the iOS app did before this line: reset a password from the phone
  // and land on the Hotelinking admin login.
  //
  // The web login is the right destination for both. A reset is completed in
  // a browser from an emailed link, and there is no deep link back into the
  // app from there — sending somebody to a page they can actually sign in on
  // beats bouncing them to a scheme the browser cannot open.
  ...forEveryGuestmakerClient("https://guestmaker.ai/login"),
  // Wifibot
  "8BRbe3Aqi76CJgYRi3TSdQasaM51MCrW": "https://wifibot.ai/auth/login",
  // Hotelinking admin
  p3Izr9GxZ3S3xDO24T0JCf2U5WE7lKvW: "https://admin.hotelinking.com/login",
};

const DEFAULT_LOGIN_URL = "https://admin.hotelinking.com/login";

export function getClientLoginUrl(clientId: string | undefined | null): string {
  if (!clientId) return DEFAULT_LOGIN_URL;
  return CLIENT_LOGIN_URL_MAP[clientId] || DEFAULT_LOGIN_URL;
}
